module.exports = __webpack_public_path__ + "static/img/187_TO8_2059_og.42dc306.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/187_TO8_2059_og.jpg
// module id = c4a1
// module chunks = 0